/** @format */
import process from "process";
const API_BASE_URL = process.env.REACT_APP_API_URL; 

export async function getDocPlan(token, instanceId) {
  const apiUrl = `${API_BASE_URL}/document/list/plans`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        InstanceId: instanceId,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
